module.exports = __webpack_public_path__ + "media/images/emblems/Mont-sur-Rolle-coat_of_arms-717ea6b572301eead2a0d5908ec4b020.svg";